

// Sync collection grid quantity inputs with cart data (no fetch)
function syncCollectionQuantities(cart) {
  if (!cart || !cart.items) {
    if (typeof applyCollectionCardDiscounts === 'function') {
      applyCollectionCardDiscounts(document.querySelector('#main-collection-product-grid') || document);
    }
    return;
  }

  document.querySelectorAll('#main-collection-product-grid quantity-input').forEach((quantityInput) => {
    if (!quantityInput.input) return;
    quantityInput.input.value = 0;
    quantityInput.previousValue = 0;
    quantityInput.handleMinusButton();
  });

  document.querySelectorAll('#main-collection-product-grid addon-overlay input[type="checkbox"]').forEach((addonInput) => {
    addonInput.checked = false;
  });

  var single = getSingleBundle();
  cart.items.forEach((item) => {
    const itemQuantityInputs = document.querySelectorAll(
      `#main-collection-product-grid quantity-input[data-id='${item.variant_id}']`
    );
    var addons = getAddOnS();
    var variant_ids = addons.variant_ids;
    if (addons.key == cart.token && variant_ids && (variant_ids.includes(item.id) || variant_ids.includes((item.id).toString()))) {
      const addon = document.querySelector(
        `#main-collection-product-grid addon-overlay input[data-id='${item.id}']`);
      if (addon) {
        addon.checked = true;
      }
    }
    if (single[item.id]) {
      for (var key in single[item.id]) {
          if(single[item.id][key]*1>0){


            const a = document.querySelector(
              `#main-collection-product-grid addon-overlay input[data-id='${key}']`);

            if (a && a.dataset.single_bundle =="true") {
              a.checked = true;
              const  x = document.querySelector(
                `#main-collection-product-grid quantity-input[data-id='${key}']`
              );
              if(x){
                x.input.value = single[item.id][key];
                x.previousValue = single[item.id][key] * 1 || 0;
                x.handleMinusButton();
              }
            }
          }
      }
    }
    // A bundle protein line ("Paired with") belongs to a salad card's pill
    // selection, not to the protein product's own card. Writing its quantity
    // into that card's stepper overwrites the standalone value that
    // syncStandaloneProteinInput just set, so the next +/- tap steps from the
    // wrong number and duplicates the protein in the cart.
    if (item.properties && item.properties['Paired with']) return;
    if (!itemQuantityInputs.length) return;
    // A product can render in more than one category section, so sync every
    // stepper bound to this variant rather than only the first in the DOM.
    itemQuantityInputs.forEach((itemQuantityInput) => {
      if (!itemQuantityInput.input) return;
      itemQuantityInput.input.value = item.quantity;
      itemQuantityInput.previousValue = item.quantity * 1 || 0;
      itemQuantityInput.handleMinusButton();
    });
  });

  if (typeof applyCollectionCardDiscounts === 'function') {
    applyCollectionCardDiscounts(document.querySelector('#main-collection-product-grid') || document);
  }
}

function set_collection_items(){

  fetch("/cart.js", {
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then((response) => response.json())
    .then((cart) => {
      try{
      updateCartProgress(cart)
      updateCartBubbles(cart);
      }
      catch(error){
        console.log(error)
      }
      syncCollectionQuantities(cart);
  
  
    });

}

set_collection_items()
document.addEventListener('cart:updated', function (event) {
  if (event && event.detail) {
    syncCollectionQuantities(event.detail);
    return;
  }

  set_collection_items();
});

function getAddOnS() {
  try {
    if (localStorage.getItem('addons')) {
      return JSON.parse(localStorage.getItem('addons'))
    }
  }
  catch (error) {

  }
  return { 'key': '', "variant_ids": [] }
}

function getSingleBundle() {
  try {
    if (localStorage.getItem('single_bundle')) {
      return JSON.parse(localStorage.getItem('single_bundle'))
    }
  }
  catch (error) {

  }
  return {}

}
